// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This is CSS that should be applied to all pages */

:root {
  --brand-blue1: #5084ec;
  --brand-blue2: #729ae9;  /* good for link decoration in dark background */
  --brand-dark1: #000000;
  --brand-dark2: #2a0600;
  --brand-dark3: #111;
  --brand-dark4: #201c1c;
  --brand-dark5: #15141a;  /* from mdn background */
  --brand-dark6: #23222b;  /* from mdn background */
  --brand-dark7: #2b2a33;  /* from mdn background */
  --brand-green1: #08fc04;
  --brand-red1: #ff0000;
  --brand-red2: #ff7300;
  --brand-red3: #ad6666;
  --brand-white1: #ffffff;
  --brand-white1-2: #f2f2f2;
  --brand-white2: #e3e3e3;
  --brand-white3: #b9b8b8;
  --brand-white4: #909090;
  --brand-white5: #6e6e6e;
  --brand-white6: #4a4a4a;
  --brand-white7: #363636;
  --btn-blue1: #2980b9;
  --btn-green1: #279923;
  --btn-red1: #d40000;
  --dim-text1: #02adad;
  --font-family1: 'Montserrat', sans-serif;
  --font-family2: "Wotfard",Futura,-apple-system,sans-serif;
  --font-family-mono: "League Mono","Fira Mono",monospace;

  --font-dots1: Serif, 'Lucida Sans Unicode', 'Lucida Sans';
  --font-dots2: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  --font-braces1: Trebuchet MS, Arial, Verdana, Tahoma, Brush Script MT;

  --color-instagram1: #f09433;
  --color-instagram2: #e6683c;
  --color-instagram3: #dc2743;
  --color-instagram4: #cc2366;
  --color-instagram5: #bc1888;
  --color-facebook1: #0062E0;
  --color-facebook2: #19AFFF;
  --color-linkedin1: #0a66c2;
  --color-twitter1: #1d9bf0;

  --text-shadow1: -1px -1px 0 #000000,1px -1px 0 #000000,-1px 1px 0 #000000,1px 1px 0 #000000;
  --text-shadow2: -1px -1px 0 var(--brand-white6),1px -1px 0 var(--brand-white6),-1px 1px 0 var(--brand-white6),1px 1px 0 var(--brand-white6);

  --rainbow-linear-gradiant: radial-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,154,0,1) 10%, rgba(208,222,33,1) 20%, rgba(79,220,74,1) 30%, rgba(63,218,216,1) 40%, rgba(47,201,226,1) 50%, rgba(28,127,238,1) 60%, rgba(95,21,242,1) 70%, rgba(186,12,248,1) 80%, rgba(251,7,217,1) 90%, rgba(255,0,0,1) 100%);

}

/* MISC */
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  word-wrap: break-word;
  /* background-color: var(--brand-dark5); */
}



/* SHORT CLASSES */
.flex {display: flex;}
.flex-col {display: flex; flex-direction: column;}
.wrap {flex-wrap: wrap;}
.align-baseline {align-items: baseline;}
.align-start {align-items: flex-start;}
.align-end {align-items: flex-end;}
.align-center {align-items: center;}
.justify-baseline {justify-content: baseline;}
.justify-start {justify-content: flex-start;}
.justify-end {justify-content: flex-end;}
.justify-center {justify-content: center;}
.justify-around {justify-content: space-around;}
.justify-between {justify-content: space-between;}

.hidden {display: none;}



/* COMMON BOX SHADOWS */
.box-shadow1 {
  border: 1px solid black;
  border-top: 1px solid var(--brand-white3);
  border-left: 1px solid var(--brand-white3);
  box-shadow: 3px 3px 3px var(--brand-white3);
}

.light-background1 {
  background-color: var(--brand-white1-2);
  border: 2px solid var(--brand-white2);
}

/* COMMON TEXT SHADOWS */

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,sBAAsB;EACtB,sBAAsB,GAAG,gDAAgD;EACzE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB,GAAG,wBAAwB;EACjD,sBAAsB,GAAG,wBAAwB;EACjD,sBAAsB,GAAG,wBAAwB;EACjD,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,yDAAyD;EACzD,uDAAuD;;EAEvD,yDAAyD;EACzD,sGAAsG;EACtG,qEAAqE;;EAErE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;;EAEzB,2FAA2F;EAC3F,2IAA2I;;EAE3I,+SAA+S;;AAEjT;;AAEA,SAAS;AACT;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,0CAA0C;AAC5C;;;;AAIA,kBAAkB;AAClB,OAAO,aAAa,CAAC;AACrB,WAAW,aAAa,EAAE,sBAAsB,CAAC;AACjD,OAAO,eAAe,CAAC;AACvB,iBAAiB,qBAAqB,CAAC;AACvC,cAAc,uBAAuB,CAAC;AACtC,YAAY,qBAAqB,CAAC;AAClC,eAAe,mBAAmB,CAAC;AACnC,mBAAmB,yBAAyB,CAAC;AAC7C,gBAAgB,2BAA2B,CAAC;AAC5C,cAAc,yBAAyB,CAAC;AACxC,iBAAiB,uBAAuB,CAAC;AACzC,iBAAiB,6BAA6B,CAAC;AAC/C,kBAAkB,8BAA8B,CAAC;;AAEjD,SAAS,aAAa,CAAC;;;;AAIvB,uBAAuB;AACvB;EACE,uBAAuB;EACvB,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,wBAAwB","sourcesContent":["/* This is CSS that should be applied to all pages */\n\n:root {\n  --brand-blue1: #5084ec;\n  --brand-blue2: #729ae9;  /* good for link decoration in dark background */\n  --brand-dark1: #000000;\n  --brand-dark2: #2a0600;\n  --brand-dark3: #111;\n  --brand-dark4: #201c1c;\n  --brand-dark5: #15141a;  /* from mdn background */\n  --brand-dark6: #23222b;  /* from mdn background */\n  --brand-dark7: #2b2a33;  /* from mdn background */\n  --brand-green1: #08fc04;\n  --brand-red1: #ff0000;\n  --brand-red2: #ff7300;\n  --brand-red3: #ad6666;\n  --brand-white1: #ffffff;\n  --brand-white1-2: #f2f2f2;\n  --brand-white2: #e3e3e3;\n  --brand-white3: #b9b8b8;\n  --brand-white4: #909090;\n  --brand-white5: #6e6e6e;\n  --brand-white6: #4a4a4a;\n  --brand-white7: #363636;\n  --btn-blue1: #2980b9;\n  --btn-green1: #279923;\n  --btn-red1: #d40000;\n  --dim-text1: #02adad;\n  --font-family1: 'Montserrat', sans-serif;\n  --font-family2: \"Wotfard\",Futura,-apple-system,sans-serif;\n  --font-family-mono: \"League Mono\",\"Fira Mono\",monospace;\n\n  --font-dots1: Serif, 'Lucida Sans Unicode', 'Lucida Sans';\n  --font-dots2: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;\n  --font-braces1: Trebuchet MS, Arial, Verdana, Tahoma, Brush Script MT;\n\n  --color-instagram1: #f09433;\n  --color-instagram2: #e6683c;\n  --color-instagram3: #dc2743;\n  --color-instagram4: #cc2366;\n  --color-instagram5: #bc1888;\n  --color-facebook1: #0062E0;\n  --color-facebook2: #19AFFF;\n  --color-linkedin1: #0a66c2;\n  --color-twitter1: #1d9bf0;\n\n  --text-shadow1: -1px -1px 0 #000000,1px -1px 0 #000000,-1px 1px 0 #000000,1px 1px 0 #000000;\n  --text-shadow2: -1px -1px 0 var(--brand-white6),1px -1px 0 var(--brand-white6),-1px 1px 0 var(--brand-white6),1px 1px 0 var(--brand-white6);\n\n  --rainbow-linear-gradiant: radial-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,154,0,1) 10%, rgba(208,222,33,1) 20%, rgba(79,220,74,1) 30%, rgba(63,218,216,1) 40%, rgba(47,201,226,1) 50%, rgba(28,127,238,1) 60%, rgba(95,21,242,1) 70%, rgba(186,12,248,1) 80%, rgba(251,7,217,1) 90%, rgba(255,0,0,1) 100%);\n\n}\n\n/* MISC */\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  word-wrap: break-word;\n  /* background-color: var(--brand-dark5); */\n}\n\n\n\n/* SHORT CLASSES */\n.flex {display: flex;}\n.flex-col {display: flex; flex-direction: column;}\n.wrap {flex-wrap: wrap;}\n.align-baseline {align-items: baseline;}\n.align-start {align-items: flex-start;}\n.align-end {align-items: flex-end;}\n.align-center {align-items: center;}\n.justify-baseline {justify-content: baseline;}\n.justify-start {justify-content: flex-start;}\n.justify-end {justify-content: flex-end;}\n.justify-center {justify-content: center;}\n.justify-around {justify-content: space-around;}\n.justify-between {justify-content: space-between;}\n\n.hidden {display: none;}\n\n\n\n/* COMMON BOX SHADOWS */\n.box-shadow1 {\n  border: 1px solid black;\n  border-top: 1px solid var(--brand-white3);\n  border-left: 1px solid var(--brand-white3);\n  box-shadow: 3px 3px 3px var(--brand-white3);\n}\n\n.light-background1 {\n  background-color: var(--brand-white1-2);\n  border: 2px solid var(--brand-white2);\n}\n\n/* COMMON TEXT SHADOWS */\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
